import { Injectable, Output, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ToasterService {
  @Output() change: EventEmitter<Toast> = new EventEmitter();

  startToast(timeOut: number, type: string, toastMessages: string[], hasCloseButton: boolean) {
    const toastMessage = this.concatenateToastMessage(toastMessages);
    const toast: Toast = new Toast(toastMessage, hasCloseButton, type, timeOut);

    this.sendToast(toast);

  }

  startWideErrorToast(errormessage: string[], messageCode: string, hasCloseButton: boolean) {
    const message = this.createMessage(errormessage, messageCode);
    const toast: Toast = new Toast(message, hasCloseButton, 'wide-error', Infinity);
    this.sendToast(toast);
  }

  startErrorToast(errormessage: string[], messageCode: string, hasCloseButton: boolean) {
    const message = this.createMessage(errormessage, messageCode);
    const toast: Toast = new Toast(message, hasCloseButton, 'error', Infinity);
    this.sendToast(toast);
  }

  private createMessage(message: string[], code: string) {
    if (code) {
      message.push(code);
    }
    return this.concatenateToastMessage(message);
  }

  private sendToast(toast: Toast) {
    this.change.emit(toast);
  }

  private concatenateToastMessage(messages: string[]): string {
    let concatenatedMessages = '';

    if (messages && messages.length > 0) {
      messages.forEach((message: string) => {
        message += '\n';
        concatenatedMessages += message;
      });
    }
    return concatenatedMessages;
  }
}

export class Toast {
  public timeOut: number | undefined;
  public type: string | undefined;
  public toastMessage: string;
  public hasCloseButton: boolean;

  constructor(
    toastMessage: string,
    hasCloseButton: boolean,
    type?: string,
    timeOut?: number,
  ) {
    this.timeOut = timeOut;
    this.type = type;
    this.toastMessage = toastMessage;
    this.hasCloseButton = hasCloseButton;

  }
}
